import React, { useState } from "react";

const SaveChangesButton = ({
  onClick,
  className = "profile-save-btn",
  label = "Save Changes",
  disabled = false,
  show = true,
}) => {
  const [saving, setSaving] = useState(false);

  if (!show) return null;

  const handleClick = async (e) => {
    if (saving || disabled) return;
    setSaving(true);
    try {
      await onClick?.(e);
    } finally {
      setSaving(false);
    }
  };

  return (
    <button
      type="button"
      className={`${className}${saving ? " is-saving" : ""}`}
      onClick={handleClick}
      disabled={disabled || saving}
    >
      {saving ? (
        <span className="save-changes-btn-content">
          <span className="save-changes-spinner" aria-hidden="true" />
          Saving...
        </span>
      ) : (
        label
      )}
    </button>
  );
};

export default SaveChangesButton;
